import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-account-create',
  templateUrl: './bank-account-create.component.html',
  styleUrls: ['./bank-account-create.component.css']
})
export class BankAccountCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
